import { cn } from "#/lib/utils";

export type FlameKind = "normal" | "blue";

const FLAME_SRC: Record<FlameKind, string> = {
  normal: "/flames/flame.svg",
  blue: "/flames/flame-blue.svg",
};

const FLAME_LABEL: Record<FlameKind, string> = {
  normal: "Streak flame",
  blue: "Long streak flame",
};

export function flameKindForStreak(dailyStreak: number): FlameKind | null {
  if (dailyStreak >= 30) return "blue";
  if (dailyStreak >= 7) return "normal";
  return null;
}

export function FlameIcon({
  kind,
  className,
  size = 16,
}: {
  kind: FlameKind;
  className?: string;
  size?: number;
}) {
  return (
    <img
      src={FLAME_SRC[kind]}
      alt={FLAME_LABEL[kind]}
      width={size}
      height={size}
      className={cn("inline-block shrink-0", className)}
      draggable={false}
    />
  );
}
